import compdraw from "./compdraw/compdraw.vue"

const components = {
  install:(vue)=>{
    // 右侧划框
    vue.component("compdraw",compdraw)
  }
}
export default components